import React from 'react';
import {useTranslation} from "react-i18next";

function AffiliateDisclosure(props) {
    const { t } = useTranslation();
    const showDisclosure = props.showDisclosure !== false;
    if (!showDisclosure) return null;

    const onlyLink = props.onlyLink;
    const text = t(onlyLink ? "disclosure.textLink" : "disclosure.textBig");
    const classText = onlyLink ? "aff_disclosure_link" : "aff_disclosure_text";

    return (
        <div className="aff_disclosure_wrap" data-nosnippet>
            <p className={classText}>
                * {text}
            </p>
        </div>
    );
}

export default AffiliateDisclosure;